module.exports = __webpack_public_path__ + "img/art-test-icon2.2e51abc8.png";